// Bracket.tsx — A hover reticle (four corner brackets) drawn around a selectable
// body to signal "scroll in to enter it". Screen-space; pointer-events:none — set
// on the <Html> wrapper itself, not just the inner .bracket, because drei sizes its
// non-transform wrapper div to the content and leaves it pointer-events:auto. Left
// auto, that 66px wrapper would steal the pointer from the body underneath the
// instant the caret appeared, firing onPointerOut → caret unmounts → onPointerOver
// → caret remounts: the reticle would flicker on every mouse move over a body.
import { Html } from '@react-three/drei';

export function Bracket() {
  return (
    <Html center zIndexRange={[15, 0]} style={{ pointerEvents: 'none' }}>
      <div className="bracket">
        <span />
        <span />
        <span />
        <span />
      </div>
    </Html>
  );
}
